<div class="p-3">
  <div class="history-header d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center gap-3">
      <div>
        <h5 class="history-title mb-1">Document Update History / Audit Trail</h5>
        <div class="event-text">
          <i class="bi bi-calendar-event me-1"></i> {{ EventId }}
        </div>
      </div>
    </div>
    <button type="button" class="history-close-btn" (click)="closeDialog()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="table-responsive mt-2">
    <div class="row mb-3 align-items-center">
      <div class="col-lg-6 col-md-8 col-sm-12 d-flex gap-2">
        <mat-form-field appearance="outline" class="search-input w-100" style="bottom: -10px;">
          <mat-label>Search here...</mat-label>
          <input matInput [(ngModel)]="pagination.searchTerm" (input)="onSearchChange(pagination.searchTerm)" placeholder="Type to search documents..." />
        </mat-form-field>
        <button type="button" class="btn btn-primary d-flex align-items-center justify-content-center" (click)="loadData()" style="height: 50px; width: 50px;">
          <i class="bi bi-search fs-5"></i>
        </button>
      </div>
    </div>

    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th style="width: 70px;">Sr.No</th>
          <th>Event Id</th>
          <th>Document Name</th>
          <th>Updated Date</th>
          <th>Action / Remark</th>
          <th style="width: 100px; text-align: center;">Attachment</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of dataSource; let i = index">
          <td>{{ (pagination.pageNumber - 1) * pagination.pageSize + i + 1 }}</td>
          <td>{{ row.EventCode || row.eventId || EventId }}</td>
          <td>{{ row.DocumentName || row.documentName || '—' }}</td>

          <td>
            <div class="text-dark fw-medium" style="font-size: 13px;">
              <i class="bi bi-clock-history me-1 text-secondary"></i>
              <span *ngIf="row.IsDeleted === 1 || row.isDeleted === 1 || row.IsDeleted === true || row.isDeleted === true">
                {{ row.updatedOn || row.DeletedOn || row.deletedOn || row.CreatedOn || row.createdOn | date:'dd/MM/yyyy hh:mm a' }}
              </span>
              <span *ngIf="row.IsDeleted === 0 || row.isDeleted === 0 || row.IsDeleted === false || row.isDeleted === false">
                {{ row.CreatedOn || row.createdOn | date:'dd/MM/yyyy hh:mm a' }}
              </span>
            </div>
          </td>

          <td>
            <span *ngIf="row.IsDeleted === 1 || row.isDeleted === 1 || row.IsDeleted === true || row.isDeleted === true"
                  class="badge bg-danger text-white px-2 py-1 rounded" style="font-size: 12px; font-weight: 500;">
              <i class="bi bi-trash-fill me-1"></i> Document Deleted
            </span>

            <span *ngIf="row.IsDeleted === 0 || row.isDeleted === 0 || row.IsDeleted === false || row.isDeleted === false"
                  class="badge bg-success text-white px-2 py-1 rounded" style="font-size: 12px; font-weight: 500;">
              <i class="bi bi-check-circle-fill me-1"></i> Active
            </span>
          </td>

          <td style="text-align: center;">
            <button *ngIf="row.FilePath || row.filePath || row.relativePath" type="button" class="btn btn-sm btn-primary" (click)="downloadFile(row)" title="Download">
              <i class="bi bi-download"></i>
            </button>
            <span *ngIf="!row.FilePath && !row.filePath && !row.relativePath">—</span>
          </td>
        </tr>
        <tr *ngIf="dataSource.length === 0">
          <td colspan="6" class="text-center text-danger fw-bold p-3">
            No document history available for this event.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalRecords"
                 [pageSize]="pagination.pageSize"
                 [pageIndex]="pagination.pageNumber - 1"
                 [pageSizeOptions]="[5, 10, 20, 50]"
                 (page)="onPageChange($event)">
  </mat-paginator>
</div>
